import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { TextButton, Icon } from "../base";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: theme.spacing(2),
    minHeight: 90,
    "&:not(:last-child)": {
      borderRight: `1px solid ${COLORS.darks[0][10]}`,
    },
    "&:nth-child(4)": {
      [theme.breakpoints.down("md")]: {
        borderRight: 0,
      },
    },
    "&:nth-child(-n+4)": {
      [theme.breakpoints.down("md")]: {
        borderBottom: `1px solid ${COLORS.darks[0][10]}`,
      },
    },
  },
}));

export const TenancyData = ({ results }) => {
  const classes = useStyles();

  return (
    <Grid container>
      {results.map((entry, index) => (
        <Grid className={classes.box} key={index} item sm={3} lg>
          <Grid container wrap="nowrap">
            {entry.image_src && <Icon style={entry.image_style} src={entry.image_src} />}
            <Box style={{ marginLeft: 5 }}>
              <Typography noWrap>{entry.title}</Typography>
              <Grid container wrap="nowrap" alignItems="baseline">
                <Typography
                  variant="h3"
                  style={{
                    textTransform: "capitalize",
                    color: entry.color ? entry.color : COLORS.darks[0][100],
                  }}
                  noWrap
                >
                  {entry.value}
                </Typography>
                {entry.unit && (
                  <Typography noWrap style={{ marginLeft: 5 }}>
                    {entry.unit}
                  </Typography>
                )}
              </Grid>
              {entry.button && <TextButton text={entry.button} normalFontWeight />}
              {entry.description && <Typography noWrap>{entry.description}</Typography>}
            </Box>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
